/* ---- Render Collections ---- */
function renderCollections(collections, artistId) {
  const grid = document.getElementById('collections-grid');
  const section = document.getElementById('section-collections');
  const viewAllLink = document.getElementById('collections-view-all');

  const marketplaceCollections = (collections || []).filter(function(collection) {
    return collection.marketplace !== false && collection.marketplace !== 'false';
  });

  if (marketplaceCollections.length === 0) {
    section.style.display = 'none';
    return;
  }

  const total = marketplaceCollections.length;
  let maxDisplay;
  let showButton;

  if (total <= 4) {
    maxDisplay = total;
    showButton = false;
  } else if (total <= 7) {
    maxDisplay = 4;
    showButton = true;
  } else if (total === 8) {
    maxDisplay = 8;
    showButton = false;
  } else {
    maxDisplay = 8;
    showButton = true;
  }

  const displayCollections = marketplaceCollections.slice(0, maxDisplay);

  viewAllLink.style.display = showButton ? '' : 'none';
  if (showButton && artistId) {
    viewAllLink.href = '/pages/artist-all-collections?id=' + encodeURIComponent(artistId);
  }

  grid.style.setProperty('--collections-columns', 4);
  if (displayCollections.length >= 4) {
    grid.classList.add('artist-collections__grid--multi');
  }

  /* Load collection tags from Shopify metafields */
  let collectionTagsData = {};
  try {
    const tagsEl = document.getElementById('collection-tags-data');
    if (tagsEl) collectionTagsData = JSON.parse(tagsEl.textContent);
  } catch (parseError) {
    console.warn('Failed to parse collection tags:', parseError);
  }

  grid.innerHTML = displayCollections.map(function(collection) {
    let badgeHtml = '';
    const handle = toHandle(collection.name);
    const shopifyTag = collectionTagsData[handle];
    if (shopifyTag) {
      badgeHtml = '<span class="artist-collection-card__badge" style="background-color:' + escapeHtml(shopifyTag.color) + '">' + escapeHtml(shopifyTag.name) + '</span>';
    }
    return '<a class="artist-collection-card" href="/products/' + toHandle(collection.name) + '">' +
      badgeHtml +
      '<div class="artist-collection-card__image-wrap">' +
        '<img class="artist-collection-card__image" src="' + escapeHtml(collection.coverUrl || '') + '" alt="' + escapeHtml(collection.name || '') + '">' +
      '</div>' +
      '<div class="artist-collection-card__text">' +
        '<div class="artist-collection-card__name">' + escapeHtml(collection.name || '') + '</div>' +
      '</div>' +
    '</a>';
  }).join('');
}
